import useSWR from "swr";
import { get, find } from "lodash";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const ProductCondition = ({ condition }) => {
  const { data: staticBlocks, isValidating } = useSWR(
    `/api/lib/v1/blocks`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  const possibleConditions = {
    "Nové z výkupu": {
      description: get(
        find(staticBlocks, ["hash", "condition_new_short_description"]),
        "content",
        ""
      ),
      content: get(
        find(staticBlocks, ["hash", "condition_new_description"]),
        "content",
        ""
      ),
    },
    "Použité - Trieda A": {
      description: get(
        find(staticBlocks, ["hash", "condition_class_a_short_description"]),
        "content",
        ""
      ),
      content: get(
        find(staticBlocks, ["hash", "condition_class_a_description"]),
        "content",
        ""
      ),
    },
    "Použité - Trieda B": {
      description: get(
        find(staticBlocks, ["hash", "condition_class_b_short_description"]),
        "content",
        ""
      ),
      content: get(
        find(staticBlocks, ["hash", "condition_class_b_description"]),
        "content",
        ""
      ),
    },
    "Použité - Trieda C": {
      description: get(
        find(staticBlocks, ["hash", "condition_class_c_short_description"]),
        "content",
        ""
      ),
      content: get(
        find(staticBlocks, ["hash", "condition_class_c_description"]),
        "content",
        ""
      ),
    },
  };

  const conditionData = get(possibleConditions, condition, null);

  return (
    <Popover
      content={
        <div
          style={{ maxWidth: "350px" }}
          dangerouslySetInnerHTML={{
            __html: isValidating
              ? "nahrávam informácie ..."
              : get(conditionData, "content"),
          }}
        />
      }
      title={<b>{condition}</b>}
      trigger="hover"
    >
      <div>
        {condition} <QuestionCircleOutlined />
        <div
          style={{ fontWeight: "lighter", fontSize: "0.8em" }}
          dangerouslySetInnerHTML={{
            __html: get(conditionData, "description"),
          }}
        />
      </div>
    </Popover>
  );
};

export default ProductCondition;
